import React from 'react';
import { Box } from '@chakra-ui/react';
import Navbar from './Navbar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box minH="100vh" overflowX="hidden">
      <Navbar />
      <Box as="main" w="full">
        {children}
      </Box>
    </Box>
  );
};

export default Layout; 